
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#005293","d":"M0 0h512v512H0z"}}),_c('path',{attrs:{"fill":"#fecb00","d":"M134 0v204.8H0v102.4h134V512h102.4V307.2H512V204.8H236.4V0z"}})])
          )
        }
      }
    